import {Enumeration} from '../../../utils/AppEnum';

export class PortOpeningRequestsDirection extends Enumeration<PortOpeningRequestsDirection> {

	// eslint-disable-next-line react/static-property-placement
	public displayName: string;

	constructor(name?: string, value?: number, displayName?: string) {
    	super(name, value);
    	this.displayName = displayName;
	}

	public static SubscriptionToInternet = new PortOpeningRequestsDirection('SubscriptionToInternet', 0, 'Subscription -> Internet');

	public static SubscriptionToOnPrem = new PortOpeningRequestsDirection('SubscriptionToOnPrem', 1, 'Subscription <-> ExxonMobil Network');
        
	public static OnPremToInternet = new PortOpeningRequestsDirection('OnPremToInternet', 2, 'OnPrem -> Internet');
    
	public static NECTUpdate = new PortOpeningRequestsDirection('NECTUpdate', 3, 'NECT Update');
    
	public static SubscriptionToSubscription = new PortOpeningRequestsDirection('SubscriptionToSubscription', 4, 'Subscription -> Subscription');
	
	public static DomainToInternet = new PortOpeningRequestsDirection('ChinaDomainToInternet', 5, 'ChinaDomain -> Internet');

	public static DomainToConnection = new PortOpeningRequestsDirection('ChinaDomainToConnection', 8, 'ChinaDomain -> Connection');

	public static DomainProxyToInternet = new PortOpeningRequestsDirection('DomainProxyToInternet', 7, 'China iBoss/Proxy -> Internet');

	public static AccountToInternet = new PortOpeningRequestsDirection('AccountToInternet', 6, 'Account -> Internet');

}
